import {
    apiRequest,
    detailDate
} from "../../../../../services/adapters/kepegawaian/employeeWFHService"

class DetailRepository {

    fetchDetailDate = async (query) => {
        return await apiRequest("get", detailDate, {
            params: query
        }, true)
    }
}

export default DetailRepository